<template>
  <div class="chart-device">
    <div class="chart-device-chart">
      <div class="chart-device-sidebar">
        <ChartDeviceDatePicker
          style="margin-bottom: var(--spacer)"
          v-model="store_chart.dates"
          v-model:compare="store_chart.compare"
        />
        <ChartDeviceDataPicker
          v-if="store_chart.getDevice"
          :dates="store_chart.dates"
          :device="store_chart.getDevice"
        />
      </div>
      <div class="chart-device-chart-inner" v-if="store_chart.isVisible">
        <DeviceChartWaste v-if="store_chart.getDevice?.code === 'SUEZ_ACTIVITE'" />
        <DeviceChartCommon v-else />
      </div>
      <LayoutCard
        background="var(--vc-secondary)"
        style="color: white; flex-grow: 1; display: flex; gap: var(--spacer)"
        v-else
      >
        <Info />
        Selectionnez une valeur pour afficher un graphique
      </LayoutCard>
    </div>
    <CompositeChartFooter @on-save="store_chart.save" />
    <template v-for="device in store_chart.getDevices" :key="device.id">
      <CompositeDeviceTotal v-if="store_chart.getDevices" :series="device.series" />
    </template>
  </div>
</template>

<script setup lang="ts">
import '@vuepic/vue-datepicker/dist/main.css'
import 'chartjs-adapter-moment'
import CompositeChartFooter from '../CompositeChartFooter.vue'
import ChartDeviceDatePicker from './ChartDeviceDatePicker.vue'
import ChartDeviceDataPicker from './ChartDeviceDataPicker.vue'
import CompositeDeviceTotal from '../CompositeDeviceTotal.vue'
import { useChartStore } from '@/stores/store_chart'

import { onMounted } from 'vue'
import LayoutCard from '@/components/layout/LayoutCard.vue'
import { Info } from 'lucide-vue-next'
import { getMonthInterval } from '@/service/service_date'
import DeviceChartCommon from './device/DeviceChartCommon.vue'
import DeviceChartWaste from './device/DeviceChartWaste.vue'

defineProps<{
  id?: number
  buildable?: boolean
}>()

const store_chart = useChartStore()
onMounted(() => {
  const month = getMonthInterval(new Date())
  if (store_chart.dates.base === undefined) {
    store_chart.dates.base = [new Date(month.first), new Date(month.last)]
  }
})
</script>

<style scoped lang="scss">
@import '@/assets/animations.scss';

.chart-device-chart {
  display: flex;
  gap: var(--spacer);
  margin-bottom: var(--spacer);
}

.chart-device-chart-inner {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: hidden;
}

.chart-device-sidebar {
  width: 350px;
  display: flex;
  flex-direction: column;
}

.tmp {
  display: flex;
  gap: 10px;
}

.tmp a {
  padding: 5px;
  background-color: lightgray;
  border-radius: 5px;
}
</style>
